const DRAFT_KEY_PREFIX = "jk:create-profile-draft:";
const DRAFT_INDEX_KEY_PREFIX = "jk:create-profile-draft-index:";

function canUseLocalStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function getCreateProfileDraftKey(user, scope = "") {
  const userKey = String(user?.id || user?.email || "default").trim() || "default";
  const scopeKey = String(scope || "").trim();
  return scopeKey
    ? `${DRAFT_KEY_PREFIX}${userKey}:${scopeKey}`
    : `${DRAFT_KEY_PREFIX}${userKey}`;
}

export function getCreateProfileDraftIndexKey(user) {
  const userKey = String(user?.id || user?.email || "default").trim() || "default";
  return `${DRAFT_INDEX_KEY_PREFIX}${userKey}`;
}

export function readCreateProfileDraft(key) {
  if (!key || !canUseLocalStorage()) return null;

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (err) {
    console.warn("Unable to read create profile draft", err);
    return null;
  }
}

export function writeCreateProfileDraft(key, draft) {
  if (!key || !canUseLocalStorage()) return;

  try {
    window.localStorage.setItem(key, JSON.stringify(draft));
  } catch (err) {
    console.warn("Unable to write create profile draft", err);
  }
}

export function clearCreateProfileDraft(key) {
  if (!key || !canUseLocalStorage()) return;

  try {
    window.localStorage.removeItem(key);
  } catch (err) {
    console.warn("Unable to clear create profile draft", err);
  }
}

export function readCreateProfileDraftIndex(key) {
  if (!key || !canUseLocalStorage()) return [];

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => item && typeof item === "object") : [];
  } catch (err) {
    console.warn("Unable to read create profile draft index", err);
    return [];
  }
}

export function writeCreateProfileDraftIndex(key, entries) {
  if (!key || !canUseLocalStorage()) return;

  try {
    window.localStorage.setItem(key, JSON.stringify(Array.isArray(entries) ? entries : []));
  } catch (err) {
    console.warn("Unable to write create profile draft index", err);
  }
}

// Duplicate-check candidates (and the chosen merge target) reference other members'
// records, so they're stripped before a draft is written to persistent storage.
export function sanitizeCreateProfileDraftForStorage(draft) {
  if (!draft || typeof draft !== "object") return draft;
  return {
    ...draft,
    duplicateMatches: [],
    duplicateTargetId: "",
  };
}

export function clearAllCreateProfileDraftsForUser(user) {
  if (!user || !canUseLocalStorage()) return;

  const indexKey = getCreateProfileDraftIndexKey(user);

  try {
    const entries = readCreateProfileDraftIndex(indexKey);
    entries.forEach((entry) => {
      if (entry?.storageKey) clearCreateProfileDraft(entry.storageKey);
    });
    clearCreateProfileDraft(indexKey);
    clearCreateProfileDraft(getCreateProfileDraftKey(user));
  } catch (err) {
    console.warn("Unable to clear create profile drafts for user", err);
  }
}
